export const AUTH_OWNER_KEY = "owner";
export const AUTH_USER_KEY = "user";
export const AUTH_WORKSPACE_KEY = "currentWorkSpace";
export const AUTH_SCHEMA_VERSION_KEY = "authSchemaVersion";
export const AUTH_SCHEMA_VERSION = "v3";

export type StoredUser = {
  userId: string;
  email: string;
  firstName?: string;
  lastName?: string;
  userBilling?: {
    stripeCustomerId?: string;
    PaymentTries?: number;
    stripePaymentFailure?: any;
    planhistory?: any[];
  } | null;
};

export const getStoredOwner = <T = any>(): T | null => {
  const raw = localStorage.getItem(AUTH_OWNER_KEY);
  if (!raw) return null;
  if (raw === "null" || raw === "undefined" || raw.trim() === "") return null;
  try {
    const parsed = JSON.parse(raw) as T | null;
    if (!parsed || typeof parsed !== "object") return null;
    return parsed as T;
  } catch {
    console.warn("[authStorage] Failed to parse stored owner; clearing stale value.");
    localStorage.removeItem(AUTH_OWNER_KEY);
    return null;
  }
};

export const setStoredOwner = (owner: unknown) => {
  localStorage.setItem(AUTH_OWNER_KEY, JSON.stringify(owner));
};

export const getStoredUser = <T = StoredUser>(): T | null => {
  const raw = localStorage.getItem(AUTH_USER_KEY);
  if (!raw) return null;
  if (raw === "null" || raw === "undefined" || raw.trim() === "") return null;
  try {
    const parsed = JSON.parse(raw) as T | null;
    if (!parsed || typeof parsed !== "object") return null;
    return parsed as T;
  } catch {
    console.warn("[authStorage] Failed to parse stored user; clearing stale value.");
    localStorage.removeItem(AUTH_USER_KEY);
    return null;
  }
};

export const setStoredUser = (user: unknown) => {
  localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user));
};

export const clearStoredAuth = () => {
  localStorage.removeItem(AUTH_OWNER_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
  localStorage.removeItem(AUTH_WORKSPACE_KEY);
  localStorage.removeItem(AUTH_SCHEMA_VERSION_KEY);
};

export const sanitizeStoredAuth = () => {
  try {
    const version = localStorage.getItem(AUTH_SCHEMA_VERSION_KEY);
    if (version !== AUTH_SCHEMA_VERSION) {
      const owner = getStoredOwner();
      if (!owner) {
        localStorage.removeItem(AUTH_OWNER_KEY);
      }
      const user = getStoredUser();
      if (!user) {
        // Migrate user identity from legacy owner payload when possible.
        const userId = (owner as any)?.userId;
        const email = (owner as any)?.userEmail || (owner as any)?.email;
        if (userId && email) {
          setStoredUser({
            userId: String(userId),
            email: String(email),
            firstName: (owner as any)?.userFirstName || undefined,
            lastName: (owner as any)?.userLastName || undefined,
          });
        } else {
          localStorage.removeItem(AUTH_USER_KEY);
        }
      }
      localStorage.setItem(AUTH_SCHEMA_VERSION_KEY, AUTH_SCHEMA_VERSION);
    } else {
      const owner = getStoredOwner();
      if (!owner) {
        localStorage.removeItem(AUTH_OWNER_KEY);
      }
      const user = getStoredUser();
      if (!user) {
        const userId = (owner as any)?.userId;
        const email = (owner as any)?.userEmail || (owner as any)?.email;
        if (userId && email) {
          setStoredUser({
            userId: String(userId),
            email: String(email),
            firstName: (owner as any)?.userFirstName || undefined,
            lastName: (owner as any)?.userLastName || undefined,
          });
        } else {
          localStorage.removeItem(AUTH_USER_KEY);
        }
      }
    }
  } catch (error) {
    console.warn("[authStorage] Failed to sanitize auth storage.", error);
  }
};
